// extracted by mini-css-extract-plugin
module.exports = {"fontsList":"FontSection_fontsList__g6gti","primaryFontFamily":"FontSection_primaryFontFamily__SwXOu","secondaryFontFamily":"FontSection_secondaryFontFamily__TtnjT"};